import service from './../utils/server'

const modName = '/common/web/select/';

/**
 * 角色
 */
export const selectRole = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};


/**
 * 仓库
 */
export const wareHouse = data => {
  return service({
    url: modName + 'wareHouse',
    method: 'post',
    data
  })
};


//根据客户编号查找收货方
export const findConsigneesByCustomerCode = data => {
  return service({
    url: modName + 'findConsigneesByCustomerCode/'+data,
    method: 'post',
    data
  });
};

//根据收货方编码获取收货地址列表
export const findAddrsByConsigneeCode = data => {
  return service({
    url: modName + 'findAddrsByConsigneeCode/'+data,
    method: 'post',
    data
  });
};

//根据收货方编码获取收货地址列表
export const findValidAddrsByCustomerCodeAndConsigneeCode = data => {
  return service({
    url: modName + 'findValidAddrsByCustomerCodeAndConsigneeCode/'+data.customerCode + '/' + data.consigneeCode,
    method: 'post',
    data
  });
};

//根据客户编码获取收货地址列表
export const findValidAddrsByCustomerCode = data => {
  return service({
    url: modName + 'findValidAddrsByCustomerCode/'+data.customerCode,
    method: 'post',
    data
  });
};

//根据客户编码获取订单类型列表
export const findOrderTypesByCustomerCode = data => {
  return service({
    url: modName + 'findOrderTypesByCustomerCode/'+data,
    method: 'post',
    data
  });
};

//根据客户编码获取订单类型列表
export const findOrderTypesByCustomerCodeForPageCreateOrder = data => {
  return service({
    url: modName + 'findOrderTypesByCustomerCodeForPageCreateOrder/'+data,
    method: 'post',
    data
  });
};

/**
 * 承运商信息
 * @param data
 */
export const getCarrierCode = data => {
  return service({
    url: modName + 'getCarrierCode',
    method: 'post',
    data
  })
};

/**m
 * 国际承运商
 * @param data
 * @returns {AxiosPromise}
 */
export const selectInternationalCarrier = data => {
  return service({
    url: modName + 'selectInternationalCarrier',
    method: 'post',
    data
  })
};

/**
 * 国内承运商
 * @param data
 * @returns {AxiosPromise}
 */
export const selectDomesticCarrier = data => {
  return service({
    url: modName + 'selectDomesticCarrier',
    method: 'post',
    data
  })
};




/**
 * 车辆
 * @param data
 */
export const findTrucksByCarrierNo = data => {
  return service({
    url: modName + 'findTrucksByCarrierNo',
    method: 'post',
    data
  })
};

/**
 * 司机
 * @param data
 */
export const findDriversByCarrierNo = data => {
  return service({
    url: modName + 'findDriversByCarrierNo',
    method: 'post',
    data
  })
};

/**
 * 客户编码下拉框
 */
export const customerCode = data => {
  return service({
    url: modName + 'selectCustomerCode',
    method: 'post',
    data
  })
};

/**
 * 收货方编码下拉框
 */
export const consigneeCode = data => {
  return service({
    url: modName + 'consigneeCode/' + data,
    method: 'post',
    data
  })
};

/**
 * 角色类型下拉框
 */
export const getRoleTypeList = data => {
  return service({
    url: modName + 'roleType',
    method: 'post',
    data
  })
};

//根据条件查询客户编码(下拉)
export const customerCodeByquery = data => {
  return service({
    url: modName + 'selectCustomerCodeByquery',
    method: 'post',
    data
  });
};


//根据条件查询sku编码(下拉)
export const selectSkuCodeByquery = data => {
  return service({
    url: modName + 'selectSkuCodeByquery',
    method: 'post',
    data
  });
};

//查询订单状态（下拉框）
export const selectOrderStatus = data => {
  return service({
    url: modName + 'selectOrderStatus',
    method: 'post',
    data
  });
};

//查询回收订单状态（下拉框）
export const selectRecyclingYardOrderStatus = data => {
  return service({
    url: modName + 'selectRecyclingYardOrderStatus',
    method: 'post',
    data
  });
};

//查询订单状态（下拉框）
export const selectOrderType = data => {
  return service({
    url: modName + 'selectOrderType',
    method: 'post',
    data
  });
};

//查询产品类型（下拉框）--sku类型下拉框
export const selectBusinessType = data => {
  return service({
    url: modName + 'selectBusinessType',
    method: 'post',
    data
  });
};

//根据条件查询收货方编码(下拉)
export const selectConsigneeCode = data => {
  return service({
    url: modName + 'selectConsigneeCode',
    method: 'post',
    data
  });
};

//根据条件查询区域编码(下拉)
export const selectRegionCode = data => {
  return service({
    url: modName + 'selectRegionCode',
    method: 'post',
    data
  });
};

//订单取消原因(下拉)
export const selectOrderCancelReason = data => {
  return service({
    url: modName + 'selectOrderCancelReason',
    method: 'post',
    data
  });
};

//回收订单取消原因(下拉)
export const selectRecyclingOrderCancelReason = data => {
  return service({
    url: modName + 'selectRecyclingOrderCancelReason',
    method: 'post',
    data
  });
};

//箱况类型(下拉)
export const selectBoxCondition = data => {
  return service({
    url: modName + 'selectBoxCondition',
    method: 'post',
    data
  });
};

//下拉框列表-订单拒绝原因(销售拒绝/发货组拒绝)
export const selectOrderRejectReason = data => {
  return service({
    url: modName + 'selectOrderRejectReason',
    method: 'post',
    data
  });
};

//查询回收订单状态（下拉框）
export const selectRecyclingOrderStatus = data => {
  return service({
    url: modName + 'selectRecyclingOrderStatus',
    method: 'post',
    data
  });
};

//最小起订量
export const selectMinqtyByCustomerno = data => {
  return service({
    url: modName + 'selectMinqtyByCustomerno/' + data,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/api/selects.js